import { ProgramContainer } from "../entities/formTemplateDataType";
import { AbstractPageRedirectHandler } from "./AbstractPageRedirectHandler";

export enum ResponseAttributes {
    SendToDCPID = 'sendToDCPID',
  }

 /**
  * To handle page-redirection related requests in PLP.
  */
export class EhocmPartnerIdPageRedirectHandler implements AbstractPageRedirectHandler {
  constructor() {}
  programContainer: ProgramContainer;

  isRedirectionRequired(): boolean {
    console.log('about to execute isRedirectionRequired in EhocmPartnerIdPageRedirectHandler...');
    const clonedUrl = new URL(window.location.href);
    const approvalStatus = clonedUrl.searchParams?.get(ResponseAttributes.SendToDCPID);

		return (!!approvalStatus);
  }

  isProcessSuccessful(): boolean {
    console.log('about to execute isProcessSuccessful in EhocmPartnerIdPageRedirectHandler...');

		return true;
  }

  getTransactionStatus(): string {
    console.log('about to execute getTransactionStatus in EhocmPartnerIdPageRedirectHandler...');
    return null;
  }

  getOrderTransactionId(): string {
    console.log('about to execute getOrderTransactionId in EhocmPartnerIdPageRedirectHandler...');
    return null;
  }

  getTransactionId(): string {
    console.log('about to execute getTransactionId in EhocmPartnerIdPageRedirectHandler...');
    const clonedUrl = new URL(window.location.href);
    const sendToDcpId = clonedUrl.searchParams?.get(ResponseAttributes.SendToDCPID);
    return sendToDcpId;
  }

  getPageForSuccessfulProcess(): number {
    return 0;
  }

  getPageForUnsuccessfulProcess(): number {
    return 0;
  }

  getErrorMessageForUnsuccessfulProcess(language: string): string {
    return null;
  }

  populateApiRequest(programContainer: ProgramContainer): void {
  }
}